import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../modules/auth/services/auth.service';
import {SETTINGS} from "../config/common.settings";

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.isLoggedIn()) {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
      return false;
    }
    const userType = this.authService.getLoggedInUser().userType;
    if ((userType === SETTINGS.USERS.ADMIN && route.routeConfig?.path === 'admin') || (userType === SETTINGS.USERS.MEMBER && route.routeConfig?.path === 'member')) {
      return true;
    } else {
      this.router.navigate(['/not-found']);
    }
    return false;
  }
}
